<script context="module">const cache = /* @__PURE__ */ new Map();
const getCache = (rootMargin) => {
  if (cache.has(rootMargin)) {
    return cache.get(rootMargin);
  }
  const item = {
    observers: /* @__PURE__ */ new WeakMap(),
    handlers: /* @__PURE__ */ new WeakMap()
  };
  cache.set(rootMargin, item);
  return item;
};
const getObserver = (root, rootMargin, element, threshold, handler) => {
  const cache2 = getCache(rootMargin);
  if (!cache2.handlers.has(element)) {
    cache2.handlers.set(element, handler);
  }
  if (cache2.observers.has(root)) {
    const observer2 = cache2.observers.get(root);
    if (observer2) {
      return observer2;
    }
  }
  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        const handler2 = cache2.handlers.get(entry.target);
        if (handler2) {
          handler2(entry);
        }
      }
    },
    {
      root,
      rootMargin,
      threshold
    }
  );
  const modifiedObserver = {
    observe: (element2) => {
      observer.observe(element2);
    },
    unobserve: (element2) => {
      observer.unobserve(element2);
      cache2.handlers.delete(element2);
    }
  };
  cache2.observers.set(root, modifiedObserver);
  return modifiedObserver;
};
</script>

<script>import { createEventDispatcher, onMount } from "svelte";
export let once = false;
export let margin = "0px";
export let root = document;
export let threshold = 0;
const dispatch = createEventDispatcher();
let intersecting = false;
let element;
let observer;
onMount(() => {
  observer = getObserver(root, margin, element, threshold, (entry) => {
    intersecting = entry.isIntersecting;
    if (intersecting) {
      dispatch("intersectionOn");
    } else {
      dispatch("intersectionOff");
    }
    if (intersecting && once) {
      observer.unobserve(element);
    }
  });
  observer.observe(element);
  return () => {
    observer.unobserve(element);
  };
});
</script>

<div {...$$restProps} bind:this={element}>
  <slot {intersecting} />
</div>
